import { environment as config } from '@coverright/shared/config';

export const environment = {
  ...config,
};
